import api from "../config/api";
import { maskUserData } from "./security";

// Check if user is authenticated
export const isAuthenticated = () => {
  const userData = localStorage.getItem("user");

  if (!userData) {
    return false;
  }

  try {
    const user = JSON.parse(userData);
    return true;
  } catch (error) {
    localStorage.removeItem("user");
    return false;
  }
};

// Get current user info
export const getCurrentUser = () => {
  const userStr = localStorage.getItem("user");
  return userStr ? JSON.parse(userStr) : null;
};

// Validate token with server
export const validateToken = async () => {
  try {
    const response = await api.get("/api/auth/validate");
    return response.data.valid;
  } catch (error) {
    return false;
  }
};

// Check if tokens are expired and logout if needed
export const checkTokenExpiration = () => {
  const accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");

  // If no tokens exist, user is not logged in
  if (!accessToken && !refreshToken) {
    return false;
  }

  // If only access token is missing but refresh token exists, allow refresh
  if (!accessToken && refreshToken) {
    return true; // Allow refresh attempt
  }

  // If access token exists, check if it's expired
  if (accessToken) {
    try {
      const payload = JSON.parse(atob(accessToken.split(".")[1]));
      const currentTime = Date.now() / 1000;

      // If token is expired and no refresh token, user should be logged out
      if (payload.exp < currentTime && !refreshToken) {
        return false;
      }

      // If token is expired but refresh token exists, allow refresh
      if (payload.exp < currentTime && refreshToken) {
        return true; // Allow refresh attempt
      }

      return true; // Token is valid
    } catch (error) {
      // If token parsing fails, user should be logged out
      return false;
    }
  }

  return false;
};

// Logout user
export const logout = async () => {
  try {
    await api.post("/api/auth/logout");
  } catch (error) {
    console.error("Logout error:", error);
  } finally {
    localStorage.removeItem("user");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
  }
};
